import React, { useEffect, useState, useCallback, useRef } from "react";

import { useLocation, useParams } from "react-router-dom";

import {
  Flex,
  Button,
  Link,
  useDisclosure,
  SimpleGrid,
  Box,
} from "@chakra-ui/react";

import LoadingSpinner from "../../../components/LoadingSpinner";

import EquipeSAService from "../../../../main/services/EquipeSAService";
import CadastrarEquipeModal from "./Cadastrar";
import Group from "./Group";
import Table from "./Table";

import { useAuthProvider } from "../../../../Context/AuthProvider";
import {
  criancaFunc,
  Permission,
  servicos,
} from "../../../../helpers/Funcionalidades";
import SemRegistros from "../../../components/SemRegistros";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import { scrollToFieldAnexo } from "../../../utils/scrollToFIeldAnexo";

const EquipeServicoAcolhimento = ({ setLoadingPainel }) => {
  const { id } = useParams();

  const {
    setCadastrarEquipeServ,
    cadastrarEquipeServ,
    editarEquipeServ,
    setEditarEquipeServ,
    idPJ,
    servicoData,
  } = useAppContext();
  const {
    isOpen: isOpenCadastro,
    onOpen: onOpenCadastro,
    onClose: onCloseCadastro,
  } = useDisclosure();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const { roleKeycloack, user } = useAuthProvider();

  const [visualizarModalEquipe, setVisualizarModalEquipe] = useState(false);
  const [visualizarModalProfissionais, setVisualizarModalProfissionais] =
    useState(false);

  const [membroId, seMembroId] = useState(null);
  const [opcaoCadastro, setOpcaoCasdastro] = useState(0);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idTipoPendencia = searchParams.get("idTipoPendencia");

  const anexoRef = useRef(null);

  const scrollToField = useCallback(
    (ref) => {
      scrollToFieldAnexo(idTipoPendencia, ref);
    },
    [idTipoPendencia]
  );

  useEffect(() => {
    if (
      ["71", "72", "73", "74", "75", "76", "77", "78"].includes(
        String(idTipoPendencia)
      )
    ) {
      const timeout = setTimeout(() => {
        requestAnimationFrame(() => {
          if (anexoRef.current) {
            scrollToField(anexoRef);
          }
        });
      }, 300);

      return () => clearTimeout(timeout);
    }
  }, [idTipoPendencia, scrollToField]);

  const columnsER = [
    {
      Header: "Nome",
      accessor: "nome",
      Cell: (props) => {
        const nome = props.value;

        return (
          <Link
            onClick={() => {
              setVisualizarModalEquipe(true);
              seMembroId(props.row.original.id);
            }}
            title={nome}
          >
            {props.value}
          </Link>
        );
      },
    },
    {
      Header: "Função",
      accessor: "funcaoEquipeAcolhimento",
      Cell: (props) => {
        return <span>{props.value.nomeFuncao}</span>;
      },
    },
    {
      Header: "Telefone",
      accessor: "telefone",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "E-mail",
      accessor: "email",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Acesso ao MCA",
      accessor: "possuiAcessoMca",
      Cell: (props) => {
        return (
          <span>
            {props.value === "S" ? "Sim" : props.value === "N" ? "Não" : ""}
          </span>
        );
      },
    },
  ];

  const columnsDPS = [
    {
      Header: "Nome",
      accessor: "nome",
      Cell: (props) => {
        const nome = props.value;
        return (
          <Link
            onClick={() => {
              setVisualizarModalProfissionais(true);
              seMembroId(props.row.original.id);
            }}
            title={nome}
          >
            {props.value}
          </Link>
        );
      },
    },
    ...(servicoData?.tipoServicoAcolhimento?.regime === "SAF"
      ? [
          {
            Header: "Função",
            accessor: "funcaoEquipeAcolhimento",
            Cell: (props) => <span>{props.value?.nomeFuncao}</span>,
          },
        ]
      : [
          {
            Header: "Cargo",
            accessor: "cargoEquipeAcolhimento",
            Cell: (props) => <span>{props.value?.nomeCargo}</span>,
          },
        ]),
    {
      Header: "Carga Horária Semanal",
      accessor: "cargaHorariaSemanal",
      Cell: (props) => {
        return <span>{props.value != null ? `${props.value}h` : ""}</span>;
      },
    },
  ];

  const handleGetEquipe = useCallback(() => {
    setLoading(true);
    EquipeSAService.getEquipeSA(id)
      .then((res) => {
        setLoading(false);
        setData(res.data);
      })
      .catch((erro) => {
        setLoading(false);
      });
  }, [id]);

  useEffect(() => {
    handleGetEquipe();
  }, [handleGetEquipe]);

  const handleCloseCadastroModal = () => {
    handleGetEquipe();
    onCloseCadastro();
  };
  return roleKeycloack &&
    (roleKeycloack.includes(servicos.equipeVisualizar) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(idPJ))) ? (
    !loading ? (
      <>
        <>
          <Flex
            flexDir="column"
            bgColor="#FFF"
            mt="25px"
            borderRadius="16px"
            py="15px"
            position={"relative"}
            px="25px"
            border={
              ["71", "73", "74", "75", "78"].includes(idTipoPendencia)
                ? "3px solid #4299E199"
                : ""
            }
            ref={anexoRef}
          >
            <Permission
              roleKeycloack={roleKeycloack}
              func={servicos.equipeCadastrar}
              id={idPJ}
              user={user}
            >
              <Button
                id="button-cadastrar-equipe"
                color="#FFF"
                backgroundColor="#169499"
                fontWeight={700}
                fontSize="15px"
                lineHeight="21.6px"
                w={{ base: "30%", lg: "17%" }}
                position={"absolute"}
                right={4}
                _hover={{ bg: "#169499" }}
                onClick={() => {
                  onOpenCadastro();
                  setOpcaoCasdastro(1);
                }}
              >
                Cadastrar
              </Button>
            </Permission>

            <Group title="Equipe de Referência">
              {data?.find(
                (membro) =>
                  membro?.tipoEquipeAcolhimento?.nomeEquipe ===
                  "Equipe de Referência"
              ) ? (
                <Box mt={4}>
                  <Table
                    data={data?.filter(
                      (membro) =>
                        membro?.tipoEquipeAcolhimento?.nomeEquipe ===
                        "Equipe de Referência"
                    )}
                    columns={columnsER}
                    handleGetEquipe={handleGetEquipe}
                    idSA={id}
                    roleKeycloack={roleKeycloack}
                    setEditarEquipeServ={setEditarEquipeServ}
                    editarEquipeServ={editarEquipeServ}
                    visualizarModal={visualizarModalEquipe}
                    setVisualizarModal={setVisualizarModalEquipe}
                    membroId={membroId}
                    user={user}
                    setLoadingPainel={setLoadingPainel}
                    equipe={true}
                  />
                </Box>
              ) : (
                <Box mt="6">
                  <SemRegistros buttonVisible={true} half />
                </Box>
              )}
            </Group>
          </Flex>
          <Flex
            flexDir="column"
            bgColor="#FFF"
            mt="25px"
            borderRadius="16px"
            py="15px"
            position={"relative"}
            px="25px"
            border={
              ["72", "76", "77"].includes(idTipoPendencia)
                ? "3px solid #4299E199"
                : ""
            }
            ref={anexoRef}
          >
            <Permission
              roleKeycloack={roleKeycloack}
              func={servicos.equipeCadastrar}
              id={idPJ}
              user={user}
            >
              <Button
                id="button-cadastrar-demais"
                color="#FFF"
                backgroundColor="#169499"
                fontWeight={700}
                fontSize="15px"
                lineHeight="21.6px"
                w={{ base: "30%", lg: "17%" }}
                position={"absolute"}
                right={4}
                _hover={{ bg: "#169499" }}
                onClick={() => {
                  onOpenCadastro();
                  setOpcaoCasdastro(2);
                }}
              >
                Cadastrar
              </Button>
            </Permission>
            <Group title="Demais Profissionais do Serviço">
              {data?.find(
                (membro) =>
                  membro?.tipoEquipeAcolhimento?.nomeEquipe ===
                  "Demais profissionais do Serviço"
              ) ? (
                <Box mt={4}>
                  <Table
                    data={data?.filter(
                      (membro) =>
                        membro?.tipoEquipeAcolhimento?.nomeEquipe ===
                        "Demais profissionais do Serviço"
                    )}
                    columns={columnsDPS}
                    handleGetEquipe={handleGetEquipe}
                    idSA={id}
                    roleKeycloack={roleKeycloack}
                    setEditarEquipeServ={setEditarEquipeServ}
                    editarEquipeServ={editarEquipeServ}
                    user={user}
                    visualizarModal={visualizarModalProfissionais}
                    setVisualizarModal={setVisualizarModalProfissionais}
                    membroId={membroId}
                    setLoadingPainel={setLoadingPainel}
                  />
                </Box>
              ) : (
                <Box mt="6">
                  <SemRegistros buttonVisible={true} half />
                </Box>
              )}
            </Group>
          </Flex>
        </>

        {isOpenCadastro && (
          <CadastrarEquipeModal
            isOpen={isOpenCadastro}
            onOpen={onOpenCadastro}
            onClose={handleCloseCadastroModal}
            setCadastrarEquipeServ={setCadastrarEquipeServ}
            cadastrarEquipeServ={cadastrarEquipeServ}
            opcaoCadastro={opcaoCadastro}
            roleKeycloack={roleKeycloack}
            setLoadingPainel={setLoadingPainel}
          />
        )}
        <SimpleGrid
          mt="30px"
          columns={{ base: 1, sm: 2, lg: 5 }}
          spacing="20px"
          dir="rtl"
        ></SimpleGrid>
      </>
    ) : (
      <Flex w="100%" mt="25%" justifyContent="center">
        <LoadingSpinner />
      </Flex>
    )
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};

export default EquipeServicoAcolhimento;
